
// function applyScript() {
//     var boldOptionTitles = document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_value_title');

//     boldOptionTitles.forEach(function (titleElement) {
//         var titleText = titleElement.textContent.trim();

//       if(titleText.includes('Font Futura PT Light')){
//         titleElement.classList.add('futuramediumbt');
//       }
//       if(titleText.includes('Font Bangers')){
//          titleElement.classList.add('BangersRegular');
//       }
//       if(titleText.includes('Font Courgette')){
//          titleElement.classList.add('Courgette');
//       }
//         if(titleText.includes('Font Alex Brush')){
//          titleElement.classList.add('AlexBrushRegular');
//       }
//          if(titleText.includes('Font Amatic SC')){
//          titleElement.classList.add('AmaticSC-Regular');
//       }
//            if(titleText.includes('Font Smooch')){
//          titleElement.classList.add('Smooch');
//       }
      
      
       
//     });
//   var inputElement = document.querySelector('.bold_option_textbox input').classList.value;
 
//    // Add event listener for radio input changes
//     document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_value input[type="checkbox"]').forEach(function (radio) {
//         radio.addEventListener('change', function () {
//           var newClass = this.closest('.bold_option_value').querySelector('.bold_option_value_title').classList.value;
//           // Set the class of the input element
//           // document.querySelector('.bold_option_textbox input').className =  inputElement +' '+ newClass;
//            document.querySelector('#displayTextBold').className = newClass;
//         });
//     });
    

// }

// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(function(){
//     document.querySelectorAll('.bold_option.bold_option_checkbox .bold_option_element input[type="checkbox"]').forEach(function (checkbox) {
//       checkbox.addEventListener('change', function () {
//          var titleChecked = this.closest('.bold_option_checkbox').querySelector('.bold_option_title').textContent.trim();
//          if(titleChecked.includes('add custom engraving')){
//         console.log("RADIO CHANGE", titleChecked);
           
//           applyScript();
//          } else {
//         console.log("RADIO CHANGE elseeee", titleChecked);
           
//          }
//       })
//     })
      
    
//   },200)
// });

$(document).ready(function() {
      console.log("newText readdy")
  
    $('body').on('input', 'input[name="properties[2. Add text]"], input[name="properties[Add text]"]', function() {
        var newText = $(this).val().trim(); // Get the new text entered in the input field and trim any leading or trailing whitespace
        $('#displayTextBold').text(newText); // Update the text of the span with the new text\
      console.log("newText", newText)    
    });
  

    function applyScript() {
        $('.bold_option.bold_option_swatch .bold_option_value_title').each(function() {
            var titleText = $(this).text().trim();
            
            if (titleText.includes('Font Futura PT Light')) {
                $(this).addClass('futuramediumbt');
            }
            if (titleText.includes('Font Bangers')) {
                $(this).addClass('BangersRegular');
            }
            if (titleText.includes('Font Courgette')) {
                $(this).addClass('Courgette');
            }
            if (titleText.includes('Font Alex Brush')) {
                $(this).addClass('AlexBrushRegular');
            }
            if (titleText.includes('Font Amatic SC')) {
                $(this).addClass('AmaticSC-Regular');
            }
            if (titleText.includes('Font Smooch')) {
                $(this).addClass('Smooch');
            }
        });
        
        var inputElementClass = $('.bold_option_textbox input').attr('class');
        
        $('body').on('change','.bold_option.bold_option_swatch .bold_option_value input[type="checkbox"]',function() {
            var newClass = $(this).closest('.bold_option_value').find('.bold_option_value_title').attr('class');
            $('#displayTextBold').removeClass().addClass(newClass);
        });
    }
    
    setTimeout(function() {
        $('body').on('change','.bold_option.bold_option_checkbox .bold_option_element input[type="checkbox"]',function() {
            var titleChecked = $(this).closest('.bold_option_checkbox').find('.bold_option_title').text().trim();
            if (titleChecked.includes('add custom engraving')) {
                console.log("RADIO CHANGE", titleChecked);
                applyScript();
            } else {
                console.log("RADIO CHANGE elseeee", titleChecked);
            }
        });
    }, 200);
    
    $(document).on('DOMContentLoaded', function() {
        applyScript();
    });
});


function hideBoldTitles() {
  const elements = document.querySelectorAll('.bold_option_title');
  let found = false;

  elements.forEach(el => {
    const text = el.textContent.trim();
    if (text === "Preview" || text === "Info:") {
      el.style.display = "none";
      found = true;
    }
  });

  return found;
}

// Keep checking every 300ms until we hide them
const interval = setInterval(() => {
  if (hideBoldTitles()) {
    clearInterval(interval); // Stop once hidden
  }
}, 100);
